module.exports = __webpack_public_path__ + "img/education5.61123373.jpeg";